import { render, staticRenderFns } from "./StudentPhotos.vue?vue&type=template&id=77313362&scoped=true&"
import script from "./StudentPhotos.vue?vue&type=script&lang=js&"
export * from "./StudentPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77313362",
  null
  
)

export default component.exports